module.exports = __webpack_public_path__ + "img/v4_adminUser_h.47e2b7a4.png";